import React, { useEffect, useState } from "react";
import { getMyProfilePicture } from "utils/getAuthConfiguration";
import { useAdUser } from "../../AuthContext";
import ProfileAvatar from "./ProfileAvatar";

interface Props {
    className?: string;
}

const MyProfileAvatar = ({ className }: Props) => {
    const adUser = useAdUser();
    const [avatarUrl, setAvatarUrl] = useState("");

    useEffect(() => {
        const getAvatarUrl = async () => {
            const url = await getMyProfilePicture();
            if (typeof url === "string") {
                setAvatarUrl(url);
            }
        };
        getAvatarUrl();
    }, []);
    return <ProfileAvatar className={className} url={avatarUrl} alt={adUser.display_name} />;
};

export default MyProfileAvatar;
